import urlJoin from 'url-join';

export function staticURL(link) {
  return urlJoin(STATIC_URL_BASE, link);
}

export function domainURL(path) {
  return urlJoin(window.location.origin, path);
}

export function getHostName(url) {
  // NOTE:
  // Will parse hostnames like so:
  // http://www.first.com/folder/page.html => first.com
  // http://mail.google.com/folder/page.html => mail.google.com
  // https://mail.google.com/folder/page.html => mail.google.com
  // http://www2.somewhere.com/folder/page.html?q=1 => somewhere.com
  // https://www.another.eu/folder/page.html?q=1 => another.eu
  //
  const match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
  if (
    match != null &&
    match.length > 2 &&
    typeof match[2] === 'string' &&
    match[2].length > 0
  ) {
    return match[2];
  }
  if (url.startsWith('www.')) {
    return url.replace('www.', '');
  }
  return url.slice();
}
export function getDomain(url) {
  const hostName = getHostName(url);
  let domain = hostName;
  if (hostName != null) {
    const parts = hostName.split('.').reverse();
    if (parts != null && parts.length > 1) {
      domain = `${parts[1]}.${parts[0]}`;
      // FIXME - review this comparison
      // eslint-disable-next-line
      if (hostName.toLowerCase().indexOf('.co.uk') != -1 && parts.length > 2) {
        domain = `${parts[2]}.${domain}`;
      }
    }
  }
  return domain;
}
